export enum PatternType {
    P2007 = 1,
    P2020 = 2
}

export const toPattern = (pattern: string | number) => {
    switch(pattern) {
        case PatternType.P2007:
            return PatternType.P2007;
        case "2007":
            return PatternType.P2007;
        default:
            return PatternType.P2020
    }
}

export enum ObjectType {
    KRO = 'KRO',
    KRTZ = 'KRTZ',
    POO = 'POO',
    POTZ = 'POTZ'
}